import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

const WIDTH = 210;
const HEIGHT = 55;
const CARET_OFFSET = 35;
const CALLS_CARET_OFFSET = 60;
const GOOGLE_INFOWINDOW_BG = '#fff';

export const StyledPopover = styled(Box)`
  width: ${WIDTH}px;
  height: ${HEIGHT}px;
  position: absolute;
  padding: 15px;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
  top: ${({ y }) => `${(y || 0) - HEIGHT - CARET_OFFSET}px`};
  left: ${({ x }) => `${(x || 0) - 0.5 * WIDTH}px`};
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.3);
  z-index: 1; // Needs a z-index > 0 for Google maps
`;
export const StyledPinnedPopover = styled(StyledPopover)`
  height: auto;
  top: ${({ y, height }) => `${(y || 0) - height - CARET_OFFSET}px`};
  padding: 8px 8px 16px 16px;
`;

export const StyledCallPopover = styled(StyledPinnedPopover)`
  background: ${GOOGLE_INFOWINDOW_BG}; //default infoWindowContent background
  color: black; //default infoWindowContent text
  font-size: 14px;
  font-weight: 200;
  top: ${({ y }) => `${(y || 0) - HEIGHT - CALLS_CARET_OFFSET}px`};
  left: ${({ x }) => `${(x || 0) - 0.5 * (WIDTH - 40)}px`};
  // to be removed once primary call is supported by DeckGl as well
  width: ${WIDTH - 40}px;
  padding: 10px;
`;

export const StyledPopoverCaret = styled(Box)`
  // the box around the caret and shadow
  width: 80px;
  height: 14px;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;

  // the caret is a square rotated 45 degrees
  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    background: ${({ theme, isGoogleMap }) =>
      isGoogleMap ? GOOGLE_INFOWINDOW_BG : theme.colors.background};
    transform: translateX(-50%) translateY(-50%) rotate(45deg);
    top: 0;
    left: 50%;
    box-shadow: 1px 1px 20px 0px rgba(0, 0, 0, 0.3);
  }
`;

export const IconWrapper = styled(Box).attrs({
  color: 'secondaryText',
  align: 'center',
})`
  cursor: ${({ pointer }) => (pointer ? 'pointer' : 'default')};
`;
